import React, { useEffect } from "react";
import { Box } from "@mui/joy";
import { useTranslation } from 'react-i18next';
import { useFormatter } from "src/mtska-frontend-app-component/utils";
import { Text } from "../Typography";
import {
    getDocumentMediaSpaHref,
    isDocumentMediaPath,
} from 'src/mtska-frontend-data-provider/redux/downloadDocumentMedia';

const DocumentAvatar = ({ document = null }) => {

    const { formatDate } = useFormatter();
    const { t } = useTranslation();

    const apiBasePath = process.env.REACT_APP_API_ENDPOINT || '';

    useEffect(() => {
        if (!document) return;
        console.info('document.name', document.name);
        if (document.name) {
            document.name = document.name.replace('undefined', '');
        } else {
            document.name = '-'
        }
    }, [document]);

    const showHref = document?.url
        ? (isDocumentMediaPath(document.url)
            ? getDocumentMediaSpaHref(document.url)
            : apiBasePath + document.url)
        : null;

    return (
        <>
            <Box className="document-avatar">
                <Text className="label id">{t('name')}</Text>
                <Box className="value document-name">{document?.name}</Box>
                <Text className="label id">{t('type')}</Text>
                <Box className="value document-type">{t(document?.type)}</Box>

                {
                    document?.documentIdentifier && (
                        <>
                            <Text className="label id">{t('documentIdentifier')}</Text>
                            <Box className="value document-type">{document?.documentIdentifier}</Box>
                        </>
                    )
                }
                {
                    document?.expire_at && (
                        <>
                            <Text className="label id">{t('expire_at')}</Text>
                            <Box className="value document-type">{formatDate(document?.expire_at)}</Box>
                        </>
                    )
                }
                {
                    showHref && (
                        <Box className="action">
                            <a href={showHref} target="_blank" rel="noreferrer" className="buttonized input-button small MuiButton-variantSolid">{t('show')}</a>
                        </Box>
                    )
                }
            </Box>
        </>
    )
}

export default DocumentAvatar;
